export default __webpack_public_path__ + "static/12_V1@2x-599292ab9da7b09934f58fd39895385d.png";